export default function onlyPersianWithNumberLatter(stringValue: string) {
    if (stringValue === "") return true;
    return RegExp(/^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C\u200F 0-9-]+$/g).test(stringValue)
}


